enum PromiseStatuses {
  fulfilled = "fulfilled",
  rejected = "rejected",
}

export default PromiseStatuses;
